import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import EmailCampaigns from './EmailCampaigns';
import EmailCampaignRoutes from './EmailCampaignRoutes';

const EmailCampaignsProtected: React.FC = () => {
  const { currentUser, viewingAllAccounts } = useAuth();

  // Allow viewing all accounts - backend will handle filtering
  // (removed check that was blocking all-accounts view)

  // Basic authentication check
  if (!currentUser) {
    return (
      <div className="container-fixed">
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
          <h4 className="font-semibold mb-1">Access Denied</h4>
          <p>You must be logged in to access this page.</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<EmailCampaigns />}>
        <Route path="*" element={<EmailCampaignRoutes />} />
      </Route>
    </Routes>
  );
};

export default EmailCampaignsProtected;